interface ComparisonBarsProps {
  yourScore: number;
  yourLabel: string;
  industryMedian: number;
  industryName: string;
  /** Tailwind background utility for "your score" bar. */
  primaryBarClassName?: string;
}

function Bar({
  label,
  value,
  className,
}: {
  label: string;
  value: number;
  className: string;
}) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
      <div className="flex items-center justify-between sm:contents">
        <span className="text-body text-current/60 sm:w-32 sm:shrink-0">
          {label}
        </span>
        <span className="text-label-lg font-medium sm:hidden">
          {value.toFixed(1)}%
        </span>
      </div>
      <div
        className="bg-current/10 relative h-4 w-full shrink-0 overflow-hidden rounded-full sm:w-auto sm:flex-1"
        role="progressbar"
        aria-label={`${label}: ${value.toFixed(1)}%`}
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`absolute left-0 top-0 h-full rounded-full transition-all duration-300 ${className}`}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      </div>
      <span className="text-label-lg hidden w-14 shrink-0 text-right font-medium sm:block">
        {value.toFixed(1)}%
      </span>
    </div>
  );
}

export function ComparisonBars({
  yourScore,
  yourLabel,
  industryMedian,
  industryName,
  primaryBarClassName = "bg-fin",
}: ComparisonBarsProps) {
  return (
    <div className="border-current/10 flex flex-col gap-3 border p-4 lg:p-5">
      <p className="text-label-lg text-current/60 font-medium">
        Score comparison
      </p>
      <div className="flex flex-col gap-3">
        <Bar
          label={yourLabel}
          value={yourScore}
          className={primaryBarClassName}
        />
        <Bar
          label={`${industryName} median`}
          value={industryMedian}
          className="bg-current/70"
        />
      </div>
    </div>
  );
}
